export function getBusinessElapsedMs(start: Date, end: Date): number {
    if (start.getTime() > end.getTime()) {
        return end.getTime() - start.getTime(); // negative fallback
    }
    
    // Shift timestamps by -3 hours so their UTC representation behaves exactly like BRT (UTC-3)
    const brtStartMs = start.getTime() - (3 * 3600 * 1000);
    const brtEndMs = end.getTime() - (3 * 3600 * 1000);
    
    let currentMs = brtStartMs;
    let businessMs = 0;
    
    while (currentMs < brtEndMs) {
        const currentDate = new Date(currentMs);
        const day = currentDate.getUTCDay(); // 0 is Sunday, 6 is Saturday
        
        // Find next midnight (00:00:00)
        const nextMidnight = new Date(currentMs);
        nextMidnight.setUTCDate(currentDate.getUTCDate() + 1);
        nextMidnight.setUTCHours(0, 0, 0, 0);
        let nextMidnightMs = nextMidnight.getTime();
        
        // Cap to end
        if (nextMidnightMs > brtEndMs) {
            nextMidnightMs = brtEndMs;
        }
        
        // Only sum if it's a weekday
        if (day !== 0 && day !== 6) {
            businessMs += (nextMidnightMs - currentMs);
        }
        
        currentMs = nextMidnightMs;
    }
    
    return businessMs;
}

export function getCorrectStartDate(dateStr: string | null | undefined): Date | null {
    if (!dateStr) return null;
    
    // Fix legacy date timestamps mapped natively to UTC midnight.
    // Equivalent to adjusting back to BRT local midnight
    if (dateStr.includes('T00:00:00') && (dateStr.endsWith('Z') || dateStr.endsWith('+00:00'))) {
        const datePart = dateStr.split('T')[0];
        return new Date(datePart + 'T00:00:00-03:00');
    }
    return new Date(dateStr);
}
